import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { MdtDispatch, MdtDispatchStatus } from '../../types';

interface DispatchState {
  dispatches: MdtDispatch[];
  activeDispatch: MdtDispatch | null; // The currently pending dispatch on MDT
}

const initialState: DispatchState = {
  dispatches: [],
  activeDispatch: null,
};

const dispatchSlice = createSlice({
  name: 'dispatch',
  initialState,
  reducers: {
    sendMdtDispatch(state, action: PayloadAction<MdtDispatch>) {
      state.dispatches.unshift(action.payload);
      // If target is the current MDT user, set as active
      state.activeDispatch = action.payload;
    },
    respondToDispatch(
      state,
      action: PayloadAction<{ id: string; status: MdtDispatchStatus; respondedAt: string }>
    ) {
      const { id, status, respondedAt } = action.payload;
      const dispatch = state.dispatches.find((d) => d.id === id);
      if (dispatch) {
        dispatch.status = status;
        dispatch.respondedAt = respondedAt;
      }
      if (state.activeDispatch?.id === id) {
        if (status === 'accepted') {
          state.activeDispatch = { ...state.activeDispatch, status, respondedAt };
        } else {
          state.activeDispatch = null;
        }
      }
    },
    cancelDispatch(state, action: PayloadAction<string>) {
      const dispatch = state.dispatches.find((d) => d.id === action.payload);
      if (dispatch) {
        dispatch.status = 'cancelled';
      }
      if (state.activeDispatch?.id === action.payload) {
        state.activeDispatch = null;
      }
    },
    completeDispatch(state, action: PayloadAction<string>) {
      const dispatch = state.dispatches.find((d) => d.id === action.payload);
      if (dispatch) {
        dispatch.status = 'completed';
      }
      if (state.activeDispatch?.id === action.payload) {
        state.activeDispatch = null;
      }
    },
    clearActiveDispatch(state) {
      state.activeDispatch = null;
    },
  },
});

export const {
  sendMdtDispatch,
  respondToDispatch,
  cancelDispatch,
  completeDispatch,
  clearActiveDispatch,
} = dispatchSlice.actions;
export default dispatchSlice.reducer;
